<div>
  <nz-select
    nzMode="multiple"
    [nzPlaceHolder]="
      label ? (label | translate) : ('page.shift.filter_labels' | translate)
    "
    [nzMaxTagCount]="1"
    nzAllowClear
    [nzShowArrow]="true"
    (ngModelChange)="saveSelected($event)"
    [ngModel]="selected$ | async"
  >
    <nz-option
      [nzLabel]="'page.service.no_label' | translate"
      [nzValue]="'no-label'"
    >
      <span nz-tooltip [nzTooltipColor]="'#fff'">
        {{ 'page.service.no_label' | translate }}
      </span>
    </nz-option>
    @for (label of options$ | async; track label) {
      <nz-option [nzLabel]="label.name" [nzValue]="label.id" nzCustomContent>
        <div class="category-container">
          <div class="dot" [style.background-color]="label.colorCode"></div>
          <div class="label-name">
            {{ label.name | translate }}
          </div>
        </div>
      </nz-option>
    }
  </nz-select>
</div>
@if (showLabel) {
  <wilson-filter-label [label]="'page.shift.filter_labels' | translate">
  </wilson-filter-label>
}
